export class SideNavTextDataES {
    static readonly htmlLabel = {
        appName: 'PREP',
        ariaMainNav: 'Menú de navegación principal',
        ariaGoDashboard: 'Ir a la página del panel',
        ariaExpandMenu: 'Expandir el menú lateral',
        ariaCollapseMenu: 'Contraer el menú lateral',

    };
    static readonly snackbarLabel = {
        signedOut: 'Sesión cerrada.',
        welcomeMyProfile: '¡Bienvenido a Mi perfil!',
        welcomeDashboard: '¡Bienvenido al panel!',
    };
    static readonly tooltipLabel = {
        userProfileText: 'Perfil',
        userLogoutText: 'Cerrar sesión',

    }
    static readonly menuLabel = {

        menuDashboard: 'Tablero',
        menuUploadFile: 'Subir Archivo',
        menuExport: 'Exportaciones',
        menuReport: 'Informes',
        menuHeaderAdminTool: 'HERRAMIENTA DE ADMINISTRACIÓN',
        menuFileUploadUsage: 'Uso de Carga de Archivos',
        menuAPIUsage: 'Uso de API',
        menuAccountConfig: 'Configuración de Cuenta',
        menuTemplateConfig: 'Configuración de Plantillas',
        menuExternalUsage: 'Uso Externo',
        menuHeaderCEAdmin: 'ADMINISTRACIÓN CE',
        menuHeaderCanvasIntegration: 'INTEGRACIÓN CANVAS',
        menuCanvasLMSFiles: 'Archivos de Canvas LMS',
        menuHeaderCivicPlusIntegration: 'INTEGRACIÓN CON CIVICPLUS',
        menuCivicPlusFiles: 'Archivos de CivicPlus',
        menuHeaderCivicPlusV2Integration: 'INTEGRACIÓN CON CIVICPLUS',
        menuCivicPlusV2Files: 'Archivos de CivicPlus',
        MenuHeaderRemediationServices: 'SERVICIOS DE REMEDIACIÓN',
        MenuHeaderBlackboardIntegration: 'INTEGRACIÓN CON BLACKBOARD',
        menuBlackboardFiles: 'Archivos de Blackboard',
        MenuHeaderWordpressIntegration: 'INTEGRACIÓN CON WORDPRESS',
        menuWordpressFiles: 'Archivos de WordPress',
        menuOrder: 'Pedidos',
        menuTransactions: 'Transacciones',
        MenuHeaderD2lIntegration: 'INTEGRACIÓN D2L',
        menuD2lLMSFiles: 'Archivos de D2L LMS',
        MenuHeaderD2lApiIntegration: 'INTEGRACIÓN D2L',
        menuD2lApiFiles: 'Archivos de D2L',
        MenuHeaderRSPAdministration: 'ADMINISTRACIÓN DEL SERVICIO RSP',
        menuCEOrders: 'Pedidos CE',
        menuUsageDashboard: 'Tablero de Uso',
        menuUsers: 'Usuarios',
        menuCEUserNotificationUser: 'Notificación al usuario de CE',
        menuExternalContact: 'Contacto externo'

    };
}